// import './assets/main.css'

import { createApp } from 'vue'
import type { Component } from 'vue'

import Dashboard from '@/views/Dashboard.vue'

initVAC('.vac-dashboard', Dashboard)

async function initVAC (selector: string, vueComponent: Component): Promise<void> {
  // const currentUrl = window.location.pathname
  // const userInfo = await getUserInfo()
  // if(userInfo.is_anonymous && !['/user/login', '/user/register', '/user/password'].includes(currentUrl)) location.href = '/user/login'

  const $elements = document.querySelectorAll<HTMLElement>(selector)
  console.log('$elements', $elements)
  if ($elements.length === 0) return

  $elements.forEach($element => {
    const props = $element.dataset.props === undefined
      ? {}
      : JSON.parse($element.dataset.props)
    createApp(vueComponent, props).mount($element)
  })
}